<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>domain</mat-icon>
        </button>
        <span>Kunde auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Kunde suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" autocomplete="off" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="customers.length > 0; else noCustomers">

            <div class="preview-entry" *ngFor="let customer of customers" (click)="customerClicked(customer)">
                <app-customer-preview [customer]="customer"></app-customer-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > customers.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{customers.length}} von {{total}}

        </div>

    </div>

</div>

<ng-template #noCustomers>

    <div class="no-customers-hint">

        <div class="text">Keine Kunden gefunden</div>

    </div>

</ng-template>
